<template>
  <div class="btn-group w-100">
    <button
      class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" aria-expanded="false"
    >
      {{ $t("selecioneUmTipo", tipo.length, { count: tipo.length }) }}
    </button>
    <ul class="dropdown-menu">
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input
              id="checkAll" class="form-check-input" type="checkbox" :checked="tipo.length == 2"
              @input="onCheckedAll"
            >
            <label class="form-check-label w-100" for="checkAll">{{ $t("todos") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check1" v-model="tipo" class="form-check-input" :value="0" type="checkbox">
            <label class="form-check-label w-100" for="check1">{{ $t("orcamento") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check2" v-model="tipo" class="form-check-input" :value="1" type="checkbox">
            <label class="form-check-label w-100" for="check2">{{ $t("ordemServico") }}</label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data: (props) => ({ tipo: props.modelValue }),
  watch: {
    tipo(newTipo) {
      if (newTipo.length > 1 && newTipo.includes(4)) this.tipo = [4];
      this.$emit('update:modelValue', this.tipo);
    },
  },
  methods: {
    onCheckedAll() { this.tipo = this.tipo.length === 2 ? [] : [0, 1]; },
  },
};
</script>
